import { Box, styled } from '@mui/material'

export const FootnoteWrapper = styled(Box)(({ theme }) => ({
  ...theme.typography.body2,
  color: theme.palette.surface[50],
  padding: theme.spacing(2, 3),

  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(2, 5),
  },
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(2, 8),
  },
  [theme.breakpoints.up('lg')]: {
    padding: theme.spacing(2, 10),
  },
  [theme.breakpoints.up('xl')]: {
    padding: theme.spacing(2, 0),
  },
  '& a': {
    color: 'inherit',
  },
}))
